import { DTC_LOCAL_PORT } from 'core/constants/environment'
import getEnvironment from 'utils/getEnvironment'

function getDTCPort() {
  return getEnvironment() === 'local' ? DTC_LOCAL_PORT.toString() : window.location.port
}

export default getDTCPort
